import { render, staticRenderFns } from "./assessment.vue?vue&type=template&id=7912573e&scoped=true"
import script from "./assessment.vue?vue&type=script&lang=js"
export * from "./assessment.vue?vue&type=script&lang=js"
import style0 from "./assessment.vue?vue&type=style&index=0&id=7912573e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7912573e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7912573e')) {
      api.createRecord('7912573e', component.options)
    } else {
      api.reload('7912573e', component.options)
    }
    module.hot.accept("./assessment.vue?vue&type=template&id=7912573e&scoped=true", function () {
      api.rerender('7912573e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/giveLesson/assessment.vue"
export default component.exports